module.exports = __webpack_public_path__ + "img/rona_2kl.69b49a6d.jpg";